__turbopack_context__.v({
  "addStopButton": "bmTNda_addStopButton",
  "createTaskForm": "bmTNda_createTaskForm",
  "errorMessage": "bmTNda_errorMessage",
  "formField": "bmTNda_formField",
  "formFieldHalfWidth": "bmTNda_formFieldHalfWidth",
  "formRow": "bmTNda_formRow",
  "formTextDisplay": "bmTNda_formTextDisplay",
  "importedMessage": "bmTNda_importedMessage",
  "locationsContainer": "bmTNda_locationsContainer",
  "organizationText": "bmTNda_organizationText",
  "setLocationsHeader": "bmTNda_setLocationsHeader",
  "taskFormTextArea": "bmTNda_taskFormTextArea",
  "taskModalContainer": "bmTNda_taskModalContainer",
  "tooltipButton": "bmTNda_tooltipButton",
  "tooltipTitle": "bmTNda_tooltipTitle",
  "tooltipWrapper": "bmTNda_tooltipWrapper",
});
